<div class="greeting-container">
    <p>BIENVENIDO/A  {{ username }}</p>
</div>
